module.exports = __webpack_public_path__ + "assets/circle-outlinezero.0463939b.svg";